'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { FacebookPixel } from '../presentation/atoms/tracking-pixels/facebook-pixel';
import { GA4Pixel } from '../presentation/atoms/tracking-pixels/ga4-pixel';

interface GlobalScriptsProps {
  userwayTreatment?: string | null;
}

export function GlobalScripts({ userwayTreatment }: GlobalScriptsProps = {}) {
  const config = getClientApplicationConfig();
  const pathname = usePathname();

  if (pathname.startsWith('/widgets')) {
    return null;
  }

  const OSANO_CUSTOMER_ID = 'wgsXXPj3qR';
  const OSANO_CONFIG_ID = '7bf45c8e-cfbe-4731-8059-e32512009be7';

  return (
    <>
      <Script
        id="osano-cmp-script"
        src={`https://cmp.osano.com/${OSANO_CUSTOMER_ID}/${OSANO_CONFIG_ID}/osano.js`}
        strategy="lazyOnload"
      ></Script>

      {userwayTreatment === 'on' && (
        <Script
          src="https://cdn.userway.org/widget.js"
          data-account="Jy1Jfc6yQm"
          strategy="afterInteractive"
        />
      )}

      <>
        {config.core.appEnvironment === 'prd' ? (
          <>
            <Script
              id="google-tag-manage-script"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(e,t,a,n){e[n]=e[n]||[],e[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});e=t.getElementsByTagName(a)[0],n=t.createElement(a);n.async=!0,n.src="https://www.googletagmanager.com/gtm.js?id=GTM-5GZQ3BH",e.parentNode.insertBefore(n,e)}(window,document,"script","dataLayer");',
              }}
            />

            <Script
              id="newsbreak-pixel"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html:
                  '!(function (e, n, t, i, p, a, s) {e[i] ||(((p = e[i] =function () {p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);}).queue = []),(p.t = +new Date()),((a = n.createElement(t)).async = 1),(a.src = "https://static.newsbreak.com/business/tracking/nbpixel.js?t=" + 864e5 * Math.ceil(new Date() / 864e5)),(s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s));})(window,document,"script","nbpix"),nbpix("init", "ID-1649485185595379713"),nbpix("event", "pageload");',
              }}
            />

            <FacebookPixel />
            <GA4Pixel />

            <Script
              id="taboola-script-1248460"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(t,e,c){document.getElementById(c)||(t.async=1,t.src="//cdn.taboola.com/libtrc/unip/1248460/tfa.js",t.id=c,e.parentNode.insertBefore(t,e))}(document.createElement("script"),document.getElementsByTagName("script")[0],"tb_tfa_script");',
              }}
            />

            <Script
              id="mediaalpha-pixel"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `new Image().src = "//insurance.mediaalpha.com/p/OoJ6UU-BDnAnPsqYoNTk2y983osKdQ.gif";`,
              }}
            />
          </>
        ) : null}
      </>
    </>
  );
}
